import React, {useEffect, useState} from 'react'
import {ChartsWidget9} from '../../dashboard/DashboardChart'
import {fetchData} from '../../../../reusable'

const ViewCategoryWiseEarning = () => {
  const [chartData, setChartData] = useState<{name: string; data: number[]}[]>([])
  const [categories, setCategories] = useState<string[]>([])
  const [totalRevenue, setTotalRevenue] = useState('')


  const fetchRevenueData = async () => {
    const res = await fetchData('admin/revenuedetail', [])
    if (res.status == '200') {
      const categoryData = res.data.category

      const totalRevenue = categoryData.map((item: any) =>
        parseFloat(item.totalAmount)
      )
        setChartData([{name: 'Revenue', data: totalRevenue}])
        setTotalRevenue(res.data.totale.totalAmount)
        setCategories(
          categoryData.map((item: any) =>
            item.categoryId == '1'
              ? 'Accommodation'
              : item.categoryId == '2'
              ? 'Restaurant'
              : item.categoryId == '4'
              ? 'Space Rental'
              : item.categoryId == '5'
              ? 'Tour Package'
              : ''
          )
        )
     
    }
  }

  useEffect(() => {
    fetchRevenueData()
    document.title = 'Insayr | View Category Wise Earning' 

  }, [])
  
  return (
    <ChartsWidget9
      className='card-xl-stretch mb-5 mb-xl-8 height440px'
      data={chartData}
      categories={categories}
      totalRevenue={totalRevenue}
    />  
    
  )
}


export default ViewCategoryWiseEarning
